import {
    Component,
    OnInit,
    Output,
    EventEmitter,
    HostListener,
    Input,
    AfterViewInit,
} from '@angular/core';

@Component({
    selector: 'search-dialog',
    templateUrl: './search-dialog.component.html',
    styleUrls: ['./search-dialog.component.scss'],
})
export class SearchDialogComponent implements OnInit, AfterViewInit {
    private _dialogSearchTerm: string;
    clearIcon: any;
    popupBox;
    isPopupBoxOpen: boolean;
    searchIcon;
    isSearchEmpty: boolean;
    searchTimeoutStorage = null;
    @Input() placeHolder? = 'Search text';
    @Input() clickAwayClose? = true;
    @Input('locationTop') popupTop? = -110;
    @Input() searchIconFontSize? = 16;
    @Input() searchIconActionColors? = ['#223540', '#223540'];
    @Input() searchBoxHeight?: number = 56;
    @Input('searchId') suffix;
    @Input() timeoutDuration = 1000;
    @Output() searchOutput: EventEmitter<string> = new EventEmitter<string>();
    @Input() set resetSearch(value: boolean) {
        if (value) {
            this.clearSearchTerm();
        }
    }

    constructor() {}

    ngOnInit() {
        this.isPopupBoxOpen = false;
        this.isSearchEmpty = true;
    }

    ngAfterViewInit() {
        this.searchIcon = document.getElementById('search-dialog-icon-' + this.suffix);
        if (this.searchIcon) {
            this.searchIcon.style.fontSize = this.searchIconFontSize.toString() + 'px';
            this.searchIcon.style.color = this.searchIconActionColors[0];
        }

        this.popupBox = document.getElementById('simple-popuup-' + this.suffix);
        if (this.popupBox) {
            this.popupBox.style.visibility = 'hidden';
            this.popupBox.style.top = this.popupTop.toString() + 'px';
        }
    }

    get dialogSearchTerm(): string {
        return this._dialogSearchTerm;
    }

    set dialogSearchTerm(value: string) {
        this._dialogSearchTerm = value;
        clearTimeout(this.searchTimeoutStorage);
        this.searchTimeoutStorage = setTimeout(() => {
            this.emitSearchOutput();
            this.setClearIcon();
        }, this.timeoutDuration);
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        if (event.key === 'Escape' && this.isPopupBoxOpen) {
            this.clearSearchTerm();
            this.closePopupDialog();
            this.setClearIcon();
        }
    }

    closePopupDialog() {
        this.searchIcon.style.color = this.searchIconActionColors[0];
        this.popupBox.style.visibility = 'hidden';
        this.isPopupBoxOpen = false;
    }

    openPopupDialog() {
        this.searchIcon.style.color = this.searchIconActionColors[1];
        this.popupBox.style.visibility = 'visible';
        this.isPopupBoxOpen = true;
    }

    openSearchDialog() {
        this.setPopupboxPosition();
        this.setClearIcon();

        if (this.clickAwayClose) {
            if (this.getPopupDialogStatus() === 'hidden') {
                this.openPopupDialog();
            } else if (this.getPopupDialogStatus() === 'visible') {
                this.closePopupDialog();
            }
        } else {
            this.openPopupDialog();
        }
    }

    getPopupDialogStatus() {
        return this.popupBox.style.visibility;
    }

    clearSearchTerm() {
        if (this._dialogSearchTerm !== '' || !this._dialogSearchTerm) {
            this._dialogSearchTerm = '';
            this.isSearchEmpty = true;
        }
    }

    cancelButtonClick(sufx: string) {
        if (sufx === this.suffix) {
            this.clearSearchTerm();
            this.emitSearchOutput();
            this.setClearIcon();
            if (this.popupBox) {
                this.closePopupDialog();
            }
        }
    }

    clearButtonClick(sufx: string) {
        if (!this.isSearchEmpty && sufx === this.suffix) {
            this.clearSearchTerm();
            this.setClearIcon();
            this.emitSearchOutput();
        }
    }

    emitSearchOutput() {
        this.searchOutput.emit(this._dialogSearchTerm);
    }

    setClearIcon() {
        this.clearIcon = document.getElementById('clear-icon-' + this.suffix);

        if (this.clearIcon) {
            if (this._dialogSearchTerm == '' || !this._dialogSearchTerm) {
                this.clearIcon.style.visibility = 'hidden';
            } else {
                this.clearIcon.style.visibility = 'visible';
            }
        }

        if (this._dialogSearchTerm == '' || !this._dialogSearchTerm) {
            this.isSearchEmpty = true;
        } else {
            this.isSearchEmpty = false;
        }
    }

    setPopupboxPosition() {
        let pageWidth = document.documentElement.clientWidth;
        let popoupParantContainer = document.getElementById(
            'search-dialog-main-container-' + this.suffix
        );

        if (this.popupBox) {
            if (popoupParantContainer.getBoundingClientRect().left + 320 > pageWidth) {
                this.popupBox.style.right = '2px';
            } else {
                this.popupBox.style.right = null;
            }
        }
    }
}
